module.exports = __webpack_public_path__ + "static/media/add-logo-tabletPro-es.f11490b6.webp";